import { useState } from "react";
import { motion } from "framer-motion";
import { Plus, Minus } from "lucide-react";

const faqs = [
  {
    q: "Comment conserver vos escargots ?",
    a: "Nos produits surgelés se conservent au congélateur jusqu'à la date indiquée. Les bocaux stérilisés se gardent à température ambiante, à l'abri de la lumière ; une fois ouverts, ils se conservent quelques jours au réfrigérateur.",
  },
  {
    q: "Comment les réchauffer / cuisiner ?",
    a: "Les Croq'Escargots et escargots en coquille se dégustent bien chauds : environ 10 minutes au four à 200°C, directement sortis du congélateur. La règle : ils sont prêts lorsque le beurre bouillonne sur toute la surface. Un régal doré et parfumé, prêt à servir.",
  },
  {
    q: "Quelle quantité prévoir par personne ?",
    a: "Comptez environ une demi-douzaine à une douzaine par personne en entrée, davantage pour un plat ou un apéritif gourmand. N'hésitez pas à nous appeler, nous vous conseillons selon votre occasion.",
  },
  {
    q: "Peut-on commander pour un événement ou en grande quantité ?",
    a: "Bien sûr ! Nous préparons des bons de commande personnalisés pour les particuliers, les associations, les comités d'entreprise et les professionnels. Contactez-nous pour étudier ensemble votre besoin.",
  },
  {
    q: "Où peut-on acheter vos produits ?",
    a: "En vente directe sur place à Savianges (sur rendez-vous), lors de nos événements, salons et marchés, ainsi que chez nos revendeurs et restaurants partenaires.",
  },
];

const FAQ = () => {
  const [open, setOpen] = useState(0);

  return (
    <section data-testid="faq-section" id="faq" className="py-24 lg:py-32 bg-sable">
      <div className="max-w-3xl mx-auto px-6 lg:px-10">
        <div className="text-center">
          <span className="text-sm uppercase tracking-[0.3em] text-mousse font-500">Bon à savoir</span>
          <h2 className="font-heading text-4xl sm:text-5xl text-foreground mt-2 tracking-tight">Questions fréquentes</h2>
        </div>

        <div className="mt-12 space-y-4">
          {faqs.map((f, i) => {
            const isOpen = open === i;
            return (
              <motion.div
                key={f.q}
                data-testid={`faq-item-${i}`}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: i * 0.05 }}
                className="rounded-2xl border border-border bg-creme overflow-hidden"
              >
                <button
                  data-testid={`faq-toggle-${i}`}
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="w-full flex items-center justify-between gap-4 text-left px-6 py-5"
                >
                  <span className="font-heading text-xl text-foreground">{f.q}</span>
                  <span className="w-8 h-8 rounded-full bg-bordeaux text-white flex items-center justify-center shrink-0">
                    {isOpen ? <Minus size={17} /> : <Plus size={17} />}
                  </span>
                </button>
                {isOpen && (
                  <div className="px-6 pb-6 -mt-1 text-foreground/75 leading-relaxed">{f.a}</div>
                )}
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
